/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImportTypeEnum,
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
} from './ImportTypeEnum';

/**
 * 
 * @export
 * @interface ImportTypeDto
 */
export interface ImportTypeDto {
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof ImportTypeDto
     */
    importType: ImportTypeEnum | null;
}

export function ImportTypeDtoFromJSON(json: any): ImportTypeDto {
    return ImportTypeDtoFromJSONTyped(json, false);
}

export function ImportTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'importType': ImportTypeEnumFromJSON(json['importType']),
    };
}

export function ImportTypeDtoToJSON(value?: ImportTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'importType': ImportTypeEnumToJSON(value.importType),
    };
}

